import React, { useCallback } from 'react';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Loading } from '@swyftx/aviary/icons/outlined';
import { EnhancedTable, EnhancedTableData } from '@swyftx/aviary/molecules/EnhancedTable';
import { MarginPosition } from '@swyftx/margin/build/types';

import { Modals } from '@global-components/Modals/Modals.enum';
import { useModal } from '@global-components/Modals/useModal.hooks';

import { MarginPositionsHealthTableData } from './MarginPositionsHealthTable.types';
import { useMarginPositionsHealthTable } from './useMarginPositionsHealthTable';

type Props = {
  className?: string;
};

const PAGE_SIZE = 10;

const MarginPositionsHealthTable: React.FC<Props> = ({ className }) => {
  const { headers, data, onSort, initialSort, hasNextPage, fetchNextPage, isFetching, isFetchingNextPage } =
    useMarginPositionsHealthTable({ pageSize: PAGE_SIZE });
  const { openModal } = useModal();

  const handleOnClickItem = useCallback(
    (item: EnhancedTableData<MarginPositionsHealthTableData, MarginPosition>) => {
      openModal(Modals.MarginPositionDetails, { positionId: item.value?.positionId });
    },
    [openModal],
  );

  return (
    <FlexLayout direction='column' spacing={0}>
      <EnhancedTable<MarginPositionsHealthTableData, MarginPosition>
        headers={headers}
        data={data}
        onSort={onSort}
        sort={initialSort}
        headerClassName='bg-color-background-surface-primary !px-16 md:!px-24'
        cellClassName='!px-16 md:!px-24'
        inset
        rowClassName='h-16 rounded-[16px]'
        itemsPerPage={PAGE_SIZE}
        className={className}
        onClickItem={handleOnClickItem}
        hasNextPage={hasNextPage}
        onFetchNextPage={fetchNextPage}
        renderDividers={false}
        isLoading={isFetchingNextPage || isFetching}
        spotlightElementId='positionHealth'
        lazyLoad={false}
      >
        <FlexLayout className='h-full w-full' alignItems='center' justifyContent='center'>
          <Loading className='animate-spin text-color-text-primary' />
        </FlexLayout>
      </EnhancedTable>
    </FlexLayout>
  );
};

export { MarginPositionsHealthTable };
